export enum StatTypeUserEnum {
  SPEAKER = 'speaker',
  ADMIN = 'admin'
}
